import { Component, OnInit, Input, HostListener, ElementRef, Output, EventEmitter, } from '@angular/core';
import { MessageService } from '../../core/services/message.service';
import { SharedService } from '../shared.service';
@Component({
  selector: 'app-job-class',
  templateUrl: './job-class.component.html',
  styleUrls: ['./job-class.component.scss']
})
export class JobClassComponent implements OnInit {

  public selectedData: any = [];//选中数据；
  public selectBox: boolean = false;//下拉框显示与隐藏
  public placeHolder: string = '选择期望岗位';
  public hopeJobData: any = [];//期望岗位列表
  public hopeOneShow: any = [];//期望岗位列表
  public hopeJobLeveTwo: any = [];//期望岗位列表
  public hopeJobLeveThr: any = [];//期望岗位列表
  @Output() selectedJobData: any = new EventEmitter(); //返回选中数据
  @Input() defaultData: any;//默认值

  public position_hope_topid: number;
  public position_hope_pid: number;
  public tmpSelected: Array<any> = [];

  constructor(
    private el: ElementRef,
    public _msg: MessageService,
    public _sharedService: SharedService,
  ) { }
  //下拉框隐藏
  @HostListener('body:click', ['$event'])
  onClick(event: any) {
    if (!this.el.nativeElement.contains(event.target)) {
      this.selectBox = false;
    }
  }


  ngOnInit() {
    setTimeout(() => {
      this._sharedService.getHopeJobData().then(resp => {
        if (resp.success) {
          this.hopeJobData = resp['data'];
          // console.log("this.hopeJobData", this.hopeJobData);
          if (!this.defaultData) {
          } else {
            this.defaultData.map(rec => {

              let name = '';
              if (rec['positionHope']) {
                name = rec['positionHope']['name'];
              } else {
                for (let item of this.hopeJobData) {
                  if (item.id === rec['position_hope_pid']) {
                    for (let ch of item.children) {
                      if (ch.id ===  rec['position_hope_id']) {
                        name = ch.name;
                        console.log(item, ch, name);
                        break;
                      }
                    }
                  }
                }
              }
              this.tmpSelected.push(
                {
                  id: rec['position_hope_id'],
                  name: name,
                  // parent_id: rec['position_hope_pid'],
                  pid: rec['position_hope_pid'],
                  topid: rec['position_hope_topid']
                });
              this.selectedData = JSON.parse(JSON.stringify(this.tmpSelected));
            });
          }
        }
      })
    }, 300);
    //获取期望岗位列表

  }
  // 获取二级类目
  getLevelTwo(topid) {
    this.position_hope_topid = topid;
    this.hopeJobLeveTwo = [];
    this.hopeJobLeveThr = [];
    this.position_hope_pid = null;
    this.hopeJobData.map(rec => {
      if (rec['id'] === topid) {
        //当点击一级类目时
        if (rec['children']) { this.hopeJobLeveTwo = rec['children']; }
      }
    })
  }
  // 获取三级类目
  getLevelThr(data) {
    // this.hopeJobLeveThr = [];
    let a = this.selectedData.findIndex(rec => rec.id === data.id);
    if (a === -1) {
      //如果不存在
      if (this.selectedData.length >= 3) {
        this._msg.warn('期望岗位最多可以选择3个');
        setTimeout(() => { this._msg.clear(); }, 3000);
        return false;
      }
      this.selectedData.push(Object.assign(data, { pid: data.parent_id }));
    } else {
      //如果以存在
      this.selectedData.splice(this.selectedData.findIndex(rec => rec['id'] == data.id), 1);
    }


    //获取二级列表
    // this.hopeJobLeveTwo.map(rec => {
    //   if (rec['id'] === pid) {
    //     if (rec['children']) {
    //       this.hopeJobLeveThr = rec['children']
    //     }
    //   }
    // })
  }
  // 选择三级类目
  getType(data) {
    let a = this.selectedData.findIndex(rec => rec.id === data.id);
    if (a === -1) {
      if (this.selectedData.length >= 3) {
        this._msg.warn('期望岗位最多可以选择3个');
        setTimeout(() => { this._msg.clear(); }, 3000);
        return false;
      }
      this.selectedData.push(Object.assign(data, { pid: this.position_hope_pid, topid: this.position_hope_topid }));
      // console.log(this.selectedData);
      this.hopeJobLeveThr.map(rec => {
        this.selectedData.map(pec => {
          if (pec['id'] === rec['id']) {
            rec['selected'] = true;
          }
        })
      })
    } else {
      this.selectedData.splice(this.selectedData.findIndex(rec => rec['id'] == data.id), 1);
      this.hopeJobLeveThr.map(rec => {
        if (rec['id'] === data.id) {
          rec['selected'] = false;
        }
      })
    }
    // console.log("aa", this.selectedData);
  }
  setClass(id, level) {

    return { 'li-active': this.isChecked(id, level) };

  }
  isChecked(id, level) {
    return this.selectedData.find(rec => {
      switch (level) {
        case 1:
          return rec.topid === id;
        case 2:
          return rec.pid === id;
        case 3:
          return rec.id === id;
      }
      return false;
    });
  }
  //确定
  selectedJob() {
    //暂存区
    this.tmpSelected = JSON.parse(JSON.stringify(this.selectedData));
    this.selectBox = false;
    let cc = [];
    this.tmpSelected.map(rec => {
      cc.push({ position_hope_id: rec['id'], position_hope_pid: rec['pid'], position_hope_topid: 0 })
    })
    // console.log("cc", cc);
    this.selectedJobData.emit(cc);
  }
  // 取消
  cancel() {
    this.selectedData = JSON.parse(JSON.stringify(this.tmpSelected));
    this.selectBox = false;
  }

  //移除数据
  removeData(did: any) {
    this.tmpSelected.splice(this.tmpSelected.findIndex(rec => rec['id'] == did), 1);
    this.selectedData.splice(this.selectedData.findIndex(rec => rec['id'] == did), 1);
    this.hopeJobLeveThr.map(rec => {
      if (rec['id'] === did) {
        rec['selected'] = false;
      }
    })
    let cc = [];
    this.tmpSelected.map(rec => {
      cc.push({ position_hope_id: rec['id'], position_hope_pid: rec['pid'], position_hope_topid: rec['topid'] })
    })
    this.selectedJobData.emit(cc);
  }
  //下拉框显示与隐藏
  widgetTarget() {
    this.selectBox = !this.selectBox;
  }

}



// WEBPACK FOOTER //
// /data/wwwroot/xzhipin/app-client/src/app/shared/job-class/job-class.component.ts